<template>
  <div class="channel-preferences">
    <h4>{{ channelTitle }}</h4>

    <template v-if="globallyUnsubscribed">
      <div class="channel-preferences__banner">
        <p class="channel-preferences__banner-msg">{{ globalUnsubscribedMsg }}</p>
        <p v-if="isPhone" class="channel-preferences__note">
          {{
            $t(
              "dashboard.donor_communication_prefs_phone_start_note",
              "If you unsubscribed by texting STOP, you must also text START to that number before SMS messages can resume."
            )
          }}
        </p>
        <button
          v-if="!narrowOpen"
          class="bttn bttn--sm bttn--orange"
          :disabled="busy"
          @click="narrowOpen = true"
        >
          {{ $t("dashboard.donor_communication_prefs_manage_btn", "Manage preferences") }}
        </button>
      </div>

      <narrow-preferences-panel
        v-if="narrowOpen"
        :campaigns="campaigns"
        :busy="busy"
        @cancel="narrowOpen = false"
        @submit="$emit('narrow', $event)"
      />
    </template>

    <template v-else>
      <div v-if="campaigns.length">
        <campaign-toggle-row
          v-for="campaign in campaigns"
          :key="campaign.id"
          :campaign="campaign"
          :busy="busyIds.includes(campaign.id)"
          @toggle="$emit('toggle', $event)"
        />
      </div>
      <p v-else class="channel-preferences__empty">
        {{
          $t(
            "dashboard.donor_communication_prefs_no_campaigns",
            "No campaigns to manage yet — campaigns appear here after you donate."
          )
        }}
      </p>
    </template>
  </div>
</template>

<script>
import campaignToggleRow from "./campaign-toggle-row.vue";
import narrowPreferencesPanel from "./narrow-preferences-panel.vue";

export default {
  components: {
    campaignToggleRow,
    narrowPreferencesPanel,
  },
  props: {
    channel: {
      type: String,
      required: true,
    },
    globallyUnsubscribed: {
      type: Boolean,
      default: false,
    },
    campaigns: {
      type: Array,
      default: () => [],
    },
    busyIds: {
      type: Array,
      default: () => [],
    },
    busy: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      narrowOpen: false,
    };
  },
  computed: {
    isPhone() {
      return this.channel === "phone";
    },
    channelTitle() {
      return this.isPhone
        ? this.$t("dashboard.donor_communication_prefs_channel_phone", "SMS")
        : this.$t("dashboard.donor_communication_prefs_channel_email", "Email");
    },
    globalUnsubscribedMsg() {
      return this.isPhone
        ? this.$t(
            "dashboard.donor_communication_prefs_global_unsub_phone",
            "You're unsubscribed from all SMS"
          )
        : this.$t(
            "dashboard.donor_communication_prefs_global_unsub_email",
            "You're unsubscribed from all email"
          );
    },
  },
};
</script>

<style lang="scss" scoped>
.channel-preferences {
  margin-top: 30px;
  h4 {
    font: 22px/1.2 "VitoExtended-Bold";
    margin-bottom: 15px;
  }
  &__banner {
    padding: 15px 20px;
    border-radius: 4px;
    background-color: #fdf3f3;
    &-msg {
      font-size: 17px;
      margin-bottom: 10px;
    }
  }
  &__note {
    font-size: 14px;
    color: #7c8a97;
    margin-bottom: 10px;
  }
  &__empty {
    font-size: 16px;
    color: #7c8a97;
  }
}
</style>
